import { render, staticRenderFns } from "./ReportRibbonsBalancesByTotals.vue?vue&type=template&id=66720168"
import script from "./ReportRibbonsBalancesByTotals.vue?vue&type=script&lang=js"
export * from "./ReportRibbonsBalancesByTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports